// Fonction utilitaire pour convertir "HH:mm" en minutes
export function toMinutes(time: string): number {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}
